import { PUBLIC_NAUTILUS_CLIENT_API_URL } from '@/app/_constants/urls'
import { setUrlParams } from '@/app/_utils/set-url-params'

import { SearchAPIResponse } from '../types'

interface Props {
    query: string
    ut: string
    signal: AbortSignal | undefined
}

export default async function fetchSearchResult({ query, ut, signal }: Props) {
    try {
        const url = setUrlParams(`${PUBLIC_NAUTILUS_CLIENT_API_URL}/catalog/search?ut=${ut}&query=${query}`)
        const response = await fetch(url, {
            signal,
        })

        if (!response.ok) throw new Error('Search results is not OK.')

        const result: SearchAPIResponse = await response.json()

        return result
    } catch (error) {
        throw new Error(`Error fetching user profile info: ${error}`)
    }
}
